<template>
  <div class="terms-outline">
    <p
      class="title"
      v-html="title"
    />
    <TermSections
      :sections="privacyPolicy"
      :level="1"
      indexDelimiter=""
    />
  </div>
</template>

<script>
import { computed, unref } from 'vue-demi'
import { useStoreGetters } from '@/store/index'
import i18n from '@/utils/i18n'
import TermSections from './TermSections'

export default {
  components: { TermSections },
  setup () {
    const { publicPathLastSelectedRegion } = useStoreGetters('regions', ['publicPathLastSelectedRegion'])
    const privacyPolicy = computed(() => {
      const region = unref(publicPathLastSelectedRegion).name
      return i18n.t(`terms.privacyPolicy.tenant.${region}.sections`)
    })
    const title = computed(() => {
      const region = unref(publicPathLastSelectedRegion).name
      return i18n.t(`terms.privacyPolicy.tenant.${region}.title`)
    })
    return {
      title,
      privacyPolicy,
    }
  },
}
</script>

<style lang="scss" scoped>
.terms-outline {
  padding: 25px 45px 25px 5px;
  background: white;
  text-align: justify;
}
.title {
  text-decoration: underline;
  font-weight: bold;
}
@page {
  size: auto; /* auto is the initial value */
  /* this affects the margin in the printer settings */
  margin-top: 15mm;
  margin-bottom: 10mm;
  margin-left: 1.82mm;
  margin-right: 1.82mm;
}
</style>
